import React from 'react';
import {Button, Checkbox, FormControlLabel, IconButton, TextField, Tooltip} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import catalogFilterToggleIcon from '../../../../../Icons/catalogFilterToggle.png';
import {technicalMapMobileMq} from './technicalMapBreakpoints';
import {technicalMapFilterToggleButtonSx, technicalMapGroupingCheckboxSx} from './technicalMapTabletFilterStyles';

const TechnicalMapTabletToolbar = ({
    isFiltersOpen,
    onToggleFilters,
    isGrouped,
    onGroupingChange,
    allExpanded,
    onToggleExpandAll,
    expandControlsDisabled,
    search,
    onSearchChange,
    onClearSearch,
}) => (
    <Box
        sx={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: 1,
            py: '7px',
            pr: '7px',
            pl: 0,
            flexWrap: 'wrap',
            [technicalMapMobileMq]: {
                flexDirection: 'column',
                alignItems: 'stretch',
            },
        }}
    >
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
                flex: '1 1 200px',
                minWidth: 0,
                justifyContent: 'flex-end',
                order: 2,
                [technicalMapMobileMq]: {
                    order: 1,
                    flex: '1 1 auto',
                    width: '100%',
                    justifyContent: 'flex-start',
                },
            }}
        >
            {!isFiltersOpen && (
                <IconButton
                    aria-label="Показать фильтры"
                    onClick={onToggleFilters}
                    sx={technicalMapFilterToggleButtonSx}
                >
                    <Box
                        component="img"
                        src={catalogFilterToggleIcon}
                        alt=""
                        aria-hidden
                        sx={{width: 16, height: 16, display: 'block'}}
                    />
                </IconButton>
            )}
            <TextField
                value={search}
                onChange={onSearchChange}
                placeholder="Поиск"
                size="small"
                variant="outlined"
                sx={{
                    width: '100%',
                    maxWidth: 320,
                    [technicalMapMobileMq]: {
                        maxWidth: 'none',
                    },
                    '& .MuiOutlinedInput-root': {
                        borderRadius: '12px',
                        height: 40,
                    },
                }}
            />
            {search && (
                <Tooltip title="Сбросить поиск">
                    <IconButton
                        size="small"
                        aria-label="Сбросить поиск"
                        onClick={onClearSearch}
                    >
                        <CloseIcon fontSize="small"/>
                    </IconButton>
                </Tooltip>
            )}
        </Box>

        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                flexShrink: 0,
                mr: 1.5,
                order: 1,
                [technicalMapMobileMq]: {
                    order: 2,
                    mr: 0,
                    width: '100%',
                },
            }}
        >
            <FormControlLabel
                sx={technicalMapGroupingCheckboxSx}
                control={(
                    <Checkbox
                        checked={isGrouped}
                        onChange={(event) => onGroupingChange(event.target.checked)}
                    />
                )}
                label="Сгруппировать по типу работы"
            />
            {!isFiltersOpen && (
                <Button
                    size="small"
                    variant="text"
                    disabled={expandControlsDisabled}
                    onClick={onToggleExpandAll}
                    sx={{
                        flexShrink: 0,
                        m: 0,
                        ml: 1,
                        pl: 0,
                        pr: 1,
                        py: 0,
                        minWidth: 0,
                        minHeight: 0,
                        justifyContent: 'flex-start',
                        textTransform: 'none',
                    }}
                >
                    {allExpanded ? 'свернуть все' : 'развернуть все'}
                </Button>
            )}
        </Box>
    </Box>
);

export default TechnicalMapTabletToolbar;
